<div class="editor-toolbar-container">
<div class="editor-toolbar" role="toolbar" aria-label="Text formatting">
  <button type="button" title="Undo" (mousedown)="$event.preventDefault()" (click)="undo()">↶</button>
  <button type="button" title="Redo" (mousedown)="$event.preventDefault()" (click)="redo()">↷</button>
  <select title="Text style" aria-label="Text style" (change)="setHeading($event)">
    <option value="paragraph">¶</option>
    <option value="1">Heading 1</option>
    <option value="2">Heading 2</option>
    <option value="3">Heading 3</option>
  </select>
  <select title="Font family" aria-label="Font family" (change)="setFontFamily($event)">
    <option value="default">Default</option>
    <option value="Arial">Arial</option>
    <option value="Georgia">Georgia</option>
    <option value="Tahoma">Tahoma</option>
    <option value="Verdana">Verdana</option>
  </select>
  <select title="Font size" aria-label="Font size" (change)="setFontSize($event)">
    <option value="default">Default</option>
    <option value="8px">8</option>
    <option value="10px">10</option>
    <option value="12px">12</option>
    <option value="14px">14</option>
    <option value="18px">18</option>
    <option value="24px">24</option>
    <option value="30px">30</option>
    <option value="36px">36</option>
    <option value="48px">48</option>
  </select>
  <select title="Line spacing" aria-label="Line spacing" (change)="setLineHeight($event)">
    <option value="default">↕</option>
    <option value="1">1</option>
    <option value="1.15">1.15</option>
    <option value="1.5">1.5</option>
    <option value="2">2</option>
  </select>
  <button type="button" title="Text color" class="color-button" (mousedown)="$event.preventDefault()" (click)="toggleColorPicker('text')">A</button>
  <button type="button" title="Background color" class="color-button background-color-button" (mousedown)="$event.preventDefault()" (click)="toggleColorPicker('background')">A</button>
  <button type="button" title="Bold" [class.active]="isActive('bold')" (mousedown)="$event.preventDefault()" (click)="toggleBold()"><strong>B</strong></button>
  <button type="button" title="Italic" [class.active]="isActive('italic')" (mousedown)="$event.preventDefault()" (click)="toggleItalic()"><em>I</em></button>
  <button type="button" title="Underline" [class.active]="isActive('underline')" (mousedown)="$event.preventDefault()" (click)="toggleUnderline()"><u>U</u></button>
  <button type="button" title="Align left" aria-label="Align left" (mousedown)="$event.preventDefault()" (click)="setAlignment('left')">
    <span class="alignment-icon align-left"><span></span><span></span><span></span></span>
  </button>
  <button type="button" title="Align center" aria-label="Align center" (mousedown)="$event.preventDefault()" (click)="setAlignment('center')">
    <span class="alignment-icon align-center"><span></span><span></span><span></span></span>
  </button>
  <button type="button" title="Align right" aria-label="Align right" (mousedown)="$event.preventDefault()" (click)="setAlignment('right')">
    <span class="alignment-icon align-right"><span></span><span></span><span></span></span>
  </button>
</div>
<button type="button" class="more-tools-button" title="More tools" aria-label="More tools"
  (mousedown)="$event.preventDefault()" (click)="toggleMoreTools()">⋮</button>
  @if (showMoreTools) {
    <div class="editor-toolbar-more">
      <button type="button" title="Link" (mousedown)="$event.preventDefault()" (click)="setLink()">🔗</button>
      <button type="button" title="Bullet list" (mousedown)="$event.preventDefault()" (click)="toggleBulletList()">•</button>
      <button type="button" title="Numbered list" (mousedown)="$event.preventDefault()" (click)="toggleOrderedList()">1.</button>
    </div>
  }
  @if (activeColorPicker === 'text') {
    <div class="color-picker-popover">
      <button type="button" (mousedown)="$event.preventDefault()" (click)="removeTextColor()">Remove color</button>
      <label>Text color <input type="color" value="#000000" aria-label="Text color" (input)="setTextColor($event)"></label>
    </div>
  }
  @if (activeColorPicker === 'background') {
    <div class="color-picker-popover">
      <button type="button" (mousedown)="$event.preventDefault()" (click)="removeBackgroundColor()">Remove color</button>
      <label>Background color <input type="color" value="#ffff00" aria-label="Background color" (input)="setBackgroundColor($event)"></label>
    </div>
  }
</div>
<div #editor class="editor-content"></div>
